import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchServices = createAsyncThunk(
  'services/fetchServices', 
  async (_,{ getState, rejectWithValue }) => {
  try {
    const token = getState().user.user?.token; 

    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/services`, {
      headers: {
        Authorization: `Bearer ${token}`, 
      },
    });
    return response?.data?.services || [];
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const initialState = {
    services: [],
    loading: false,
    error: null,
  };
  
const carrierSlice = createSlice({
  name: 'carriers',
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchServices.fulfilled, (state, action) => {
        state.loading = false;
        state.services = action.payload || [];
        state.error = null;
      })
      .addCase(fetchServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetState: resetCarriers } = carrierSlice.actions;
export default carrierSlice.reducer;
